/** Mappt Readiness-Verstöße (per Channel) → OptimierungField[] für den Drawer. */
import type { OptimierungField, AttributeCode } from './optimierungenTypes'

type RawIssue = { issue_type: string; field: string; message: string; severity: string; expected?: string; actual?: string }

const IN_SCOPE: AttributeCode[] = ['title', 'description', 'short_description', 'bullets']
const COST: Record<AttributeCode, number> = { title: 5, description: 5, short_description: 3, bullets: 8 }

/** Aus den (Text-)Verstößen eines Channels die behebbaren Felder im rest-Status bauen. */
export function buildOptimierungFields(issues: RawIssue[]): OptimierungField[] {
  const out: OptimierungField[] = []
  for (const code of IN_SCOPE) {
    const issue = issues.find((i) => i.issue_type === 'text' && i.field === code)
    if (!issue) continue
    const missing = /fehlt|erforderlich|required|leer/i.test(issue.message)
    out.push({
      attributeCode: code,
      kind: missing ? 'warn' : 'err',
      status: 'rest',
      statusLabel: missing ? 'Fehlt' : 'Regel verletzt',
      reason: issue.actual && issue.expected ? `${issue.actual} → ${issue.expected}` : issue.message,
      cost: COST[code],
      proactive: false,
    })
  }
  return out
}
